import { cn } from '../lib/utils';

export default function GlassCard({ children, className = '', hover = false, glow = false, ...props }) {
  return (
    <div
      className={cn(
        'glass rounded-2xl p-6',
        hover && 'lift cursor-pointer',
        glow && 'animate-pulse-glow',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
